/* Botirry Size Guide — pure JS injection (asset files persist) */
(function(){
  // Only run on product pages
  if (!document.body.dataset.template && !window.location.pathname.startsWith('/products/')) return;
  if (document.body.dataset.template && document.body.dataset.template !== 'product') return;

  // CSS
  var css = document.createElement('style');
  css.textContent = '\
    .botirry-sg-modal{display:none;position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:99999;align-items:flex-start;justify-content:center;padding:40px 16px;overflow-y:auto}\
    .botirry-sg-modal.is-open{display:flex}\
    .botirry-sg-inner{background:#fff;max-width:720px;width:100%;border-radius:10px;padding:32px;position:relative;box-shadow:0 20px 60px rgba(0,0,0,.25);font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif}\
    .botirry-sg-close{position:absolute;top:12px;right:16px;background:none;border:none;font-size:32px;color:#999;cursor:pointer;line-height:1}\
    .botirry-sg-close:hover{color:#1a1a1a}\
    .botirry-sg-h3{font-size:16px;color:#1a1a1a;margin:24px 0 10px;padding-bottom:6px;border-bottom:2px solid #FF6B35;font-weight:700}\
    .botirry-sg-h3:first-of-type{margin-top:8px}\
    .botirry-sg-wrap{overflow-x:auto;margin-bottom:12px}\
    .botirry-sg-tbl{width:100%;border-collapse:collapse;font-size:13px}\
    .botirry-sg-tbl th{background:#f9f9f9;color:#1a1a1a;font-weight:700;padding:10px 12px;text-align:left;border-bottom:2px solid #e5e5e5;white-space:nowrap}\
    .botirry-sg-tbl td{padding:9px 12px;border-bottom:1px solid #f0f0f0;color:#1a1a1a}\
    .botirry-sg-tbl tr:hover td{background:#fff7f3}\
    .botirry-sg-tip{margin-top:24px;padding:16px;background:#fff7f3;border-radius:6px;font-size:13px;color:#1a1a1a;line-height:1.5}\
    .botirry-sg-btn{background:none;border:none;color:#FF6B35;font-size:13px;font-weight:600;cursor:pointer;text-decoration:underline;padding:0;display:inline-flex;align-items:center;gap:6px;margin-left:auto}\
    @media (max-width:600px){.botirry-sg-inner{padding:24px 16px}.botirry-sg-tbl{font-size:12px}.botirry-sg-tbl th,.botirry-sg-tbl td{padding:8px}}';
  document.head.appendChild(css);

  // Size charts
  var charts = {
    hawaiian: '\
      <h3 class="botirry-sg-h3">Hawaiian Shirt (Adult)</h3>\
      <div class="botirry-sg-wrap"><table class="botirry-sg-tbl">\
        <thead><tr><th>Size</th><th>Chest</th><th>Length</th><th>Sleeve</th><th>Fits chest</th></tr></thead>\
        <tbody>\
          <tr><td>S</td><td>20.0"</td><td>28.5"</td><td>9.0"</td><td>34-36"</td></tr>\
          <tr><td>M</td><td>22.0"</td><td>29.5"</td><td>9.5"</td><td>38-40"</td></tr>\
          <tr><td>L</td><td>24.0"</td><td>30.5"</td><td>10.0"</td><td>42-44"</td></tr>\
          <tr><td>XL</td><td>26.0"</td><td>31.5"</td><td>10.5"</td><td>46-48"</td></tr>\
          <tr><td>2XL</td><td>28.0"</td><td>32.5"</td><td>11.0"</td><td>50-52"</td></tr>\
          <tr><td>3XL</td><td>30.0"</td><td>33.5"</td><td>11.5"</td><td>54-56"</td></tr>\
          <tr><td>4XL</td><td>32.0"</td><td>34.5"</td><td>12.0"</td><td>58-60"</td></tr>\
          <tr><td>5XL</td><td>34.0"</td><td>35.5"</td><td>12.5"</td><td>62-64"</td></tr>\
        </tbody></table></div>\
      <h3 class="botirry-sg-h3">Beach Shorts (Men)</h3>\
      <div class="botirry-sg-wrap"><table class="botirry-sg-tbl">\
        <thead><tr><th>Size</th><th>Waist</th><th>Inseam</th><th>Hip</th></tr></thead>\
        <tbody>\
          <tr><td>S</td><td>28-30"</td><td>7.5"</td><td>36-38"</td></tr>\
          <tr><td>M</td><td>30-32"</td><td>8.0"</td><td>38-40"</td></tr>\
          <tr><td>L</td><td>32-34"</td><td>8.5"</td><td>40-42"</td></tr>\
          <tr><td>XL</td><td>34-36"</td><td>9.0"</td><td>42-44"</td></tr>\
          <tr><td>2XL</td><td>36-38"</td><td>9.5"</td><td>44-46"</td></tr>\
          <tr><td>3XL</td><td>38-40"</td><td>10.0"</td><td>46-48"</td></tr>\
          <tr><td>4XL</td><td>40-42"</td><td>10.5"</td><td>48-50"</td></tr>\
          <tr><td>5XL</td><td>42-44"</td><td>11.0"</td><td>50-52"</td></tr>\
        </tbody></table></div>\
      <h3 class="botirry-sg-h3">Kid Hawaiian Shirt</h3>\
      <div class="botirry-sg-wrap"><table class="botirry-sg-tbl">\
        <thead><tr><th>Size</th><th>Age</th><th>Chest</th><th>Length</th></tr></thead>\
        <tbody>\
          <tr><td>XS</td><td>2-3 yrs</td><td>13.5"</td><td>16.5"</td></tr>\
          <tr><td>S</td><td>4-5 yrs</td><td>14.5"</td><td>18.0"</td></tr>\
          <tr><td>M</td><td>6-7 yrs</td><td>15.5"</td><td>19.5"</td></tr>\
          <tr><td>L</td><td>8-9 yrs</td><td>16.5"</td><td>21.0"</td></tr>\
          <tr><td>XL</td><td>10-12 yrs</td><td>18.0"</td><td>22.5"</td></tr>\
        </tbody></table></div>',
    aop: '\
      <h3 class="botirry-sg-h3">T-Shirt / Long Sleeve / Tank Top</h3>\
      <div class="botirry-sg-wrap"><table class="botirry-sg-tbl">\
        <thead><tr><th>Size</th><th>Chest</th><th>Length</th><th>Sleeve (LS)</th></tr></thead>\
        <tbody>\
          <tr><td>S</td><td>20.0"</td><td>28.0"</td><td>24.0"</td></tr>\
          <tr><td>M</td><td>22.0"</td><td>29.0"</td><td>24.5"</td></tr>\
          <tr><td>L</td><td>24.0"</td><td>30.0"</td><td>25.0"</td></tr>\
          <tr><td>XL</td><td>26.0"</td><td>31.0"</td><td>25.5"</td></tr>\
          <tr><td>2XL</td><td>28.0"</td><td>32.0"</td><td>26.0"</td></tr>\
          <tr><td>3XL</td><td>30.0"</td><td>33.0"</td><td>26.5"</td></tr>\
          <tr><td>4XL</td><td>32.0"</td><td>34.0"</td><td>27.0"</td></tr>\
          <tr><td>5XL</td><td>34.0"</td><td>35.0"</td><td>27.5"</td></tr>\
        </tbody></table></div>\
      <h3 class="botirry-sg-h3">Polo Shirt</h3>\
      <div class="botirry-sg-wrap"><table class="botirry-sg-tbl">\
        <thead><tr><th>Size</th><th>Chest</th><th>Length</th><th>Shoulder</th></tr></thead>\
        <tbody>\
          <tr><td>S</td><td>20.5"</td><td>28.5"</td><td>17.5"</td></tr>\
          <tr><td>M</td><td>22.5"</td><td>29.5"</td><td>18.0"</td></tr>\
          <tr><td>L</td><td>24.5"</td><td>30.5"</td><td>18.5"</td></tr>\
          <tr><td>XL</td><td>26.5"</td><td>31.5"</td><td>19.0"</td></tr>\
          <tr><td>2XL</td><td>28.5"</td><td>32.5"</td><td>19.5"</td></tr>\
          <tr><td>3XL</td><td>30.5"</td><td>33.5"</td><td>20.0"</td></tr>\
          <tr><td>4XL</td><td>32.5"</td><td>34.5"</td><td>20.5"</td></tr>\
          <tr><td>5XL</td><td>34.5"</td><td>35.5"</td><td>21.0"</td></tr>\
        </tbody></table></div>\
      <h3 class="botirry-sg-h3">Hoodie / Sweatshirt / Crewneck</h3>\
      <div class="botirry-sg-wrap"><table class="botirry-sg-tbl">\
        <thead><tr><th>Size</th><th>Chest</th><th>Length</th><th>Sleeve</th></tr></thead>\
        <tbody>\
          <tr><td>S</td><td>21.0"</td><td>27.5"</td><td>24.5"</td></tr>\
          <tr><td>M</td><td>23.0"</td><td>28.5"</td><td>25.0"</td></tr>\
          <tr><td>L</td><td>25.0"</td><td>29.5"</td><td>25.5"</td></tr>\
          <tr><td>XL</td><td>27.0"</td><td>30.5"</td><td>26.0"</td></tr>\
          <tr><td>2XL</td><td>29.0"</td><td>31.5"</td><td>26.5"</td></tr>\
          <tr><td>3XL</td><td>32.5"</td><td>32.5"</td><td>27.0"</td></tr>\
          <tr><td>4XL</td><td>33.0"</td><td>33.5"</td><td>27.5"</td></tr>\
          <tr><td>5XL</td><td>35.0"</td><td>34.5"</td><td>28.0"</td></tr>\
        </tbody></table></div>',
    drinkware: '\
      <h3 class="botirry-sg-h3">40oz Insulated Tumbler</h3>\
      <div class="botirry-sg-wrap"><table class="botirry-sg-tbl">\
        <thead><tr><th>Spec</th><th>Value</th></tr></thead>\
        <tbody>\
          <tr><td>Capacity</td><td>40 oz / 1182 ml</td></tr>\
          <tr><td>Height</td><td>11.5"</td></tr>\
          <tr><td>Diameter (top)</td><td>3.5"</td></tr>\
          <tr><td>Diameter (base)</td><td>3.0"</td></tr>\
          <tr><td>Weight</td><td>1.4 lbs / 635 g</td></tr>\
          <tr><td>Material</td><td>18/8 stainless steel, BPA-free</td></tr>\
          <tr><td>Insulation</td><td>Cold 24h / Hot 12h</td></tr>\
        </tbody></table></div>\
      <h3 class="botirry-sg-h3">11oz Ceramic Mug</h3>\
      <div class="botirry-sg-wrap"><table class="botirry-sg-tbl">\
        <thead><tr><th>Spec</th><th>Value</th></tr></thead>\
        <tbody>\
          <tr><td>Capacity</td><td>11 oz / 325 ml</td></tr>\
          <tr><td>Height</td><td>3.7"</td></tr>\
          <tr><td>Diameter</td><td>3.2"</td></tr>\
          <tr><td>Weight</td><td>0.8 lbs / 363 g</td></tr>\
          <tr><td>Material</td><td>Premium ceramic, dishwasher-safe</td></tr>\
          <tr><td>Print</td><td>Full-wrap sublimation, microwave-safe</td></tr>\
        </tbody></table></div>\
      <h3 class="botirry-sg-h3">15oz Ceramic Mug</h3>\
      <div class="botirry-sg-wrap"><table class="botirry-sg-tbl">\
        <thead><tr><th>Spec</th><th>Value</th></tr></thead>\
        <tbody>\
          <tr><td>Capacity</td><td>15 oz / 443 ml</td></tr>\
          <tr><td>Height</td><td>4.7"</td></tr>\
          <tr><td>Diameter</td><td>3.4"</td></tr>\
          <tr><td>Weight</td><td>1.1 lbs / 500 g</td></tr>\
          <tr><td>Material</td><td>Premium ceramic, dishwasher-safe</td></tr>\
          <tr><td>Print</td><td>Full-wrap sublimation, microwave-safe</td></tr>\
        </tbody></table></div>'
  };

  // Detect product type from multiple sources (most reliable first)
  function detectType(){
    var hints = '';

    // 1. Best: read product.type from Shopify Analytics tracking call
    //    Format in HTML: "category":"Hawaiian Shirt"
    try {
      var html = document.documentElement.outerHTML || '';
      var m = html.match(/"category":"([^"]+)"/);
      if (m && m[1]) hints += ' ' + m[1].toLowerCase();
    } catch(_){}

    // 2. Read variant Style option from window._themeProducts
    try {
      if (window._themeProducts) {
        for (var pid in window._themeProducts) {
          var p = window._themeProducts[pid];
          if (p && p.variants && p.variants.length) {
            (p.options || []).forEach(function(opt){
              (opt.values || []).forEach(function(v){ hints += ' ' + v.toLowerCase(); });
            });
            break;
          }
        }
      }
    } catch(_){}

    // 3. Fallback: title, h1, URL
    hints += ' ' + (document.title || '').toLowerCase();
    var h1 = (document.querySelector('h1.m-product-title, h1.product-title, h1') || {}).textContent || '';
    hints += ' ' + h1.toLowerCase();
    hints += ' ' + window.location.pathname.toLowerCase();

    // Match priority: tumbler/mug first (most specific), then hawaiian, then aop
    if (hints.indexOf('tumbler') !== -1 || hints.indexOf('drinkware') !== -1 || hints.indexOf('mug') !== -1) return 'drinkware';
    if (hints.indexOf('hawaiian') !== -1 || hints.indexOf('beach short') !== -1) return 'hawaiian';
    if (hints.indexOf('all over print') !== -1 || hints.indexOf('aop') !== -1 || hints.indexOf('apparel') !== -1 ||
        hints.indexOf('t-shirt') !== -1 || hints.indexOf('polo') !== -1 || hints.indexOf('hoodie') !== -1 ||
        hints.indexOf('sweatshirt') !== -1 || hints.indexOf('tank top') !== -1 || hints.indexOf('crewneck') !== -1 ||
        hints.indexOf('long sleeve') !== -1) return 'aop';
    return 'aop'; // safe default
  }

  // Build modal once
  function buildModal(){
    if (document.getElementById('botirry-sg-modal')) return;
    var t = detectType();
    var modal = document.createElement('div');
    modal.id = 'botirry-sg-modal';
    modal.className = 'botirry-sg-modal';
    var heading = t === 'drinkware' ? 'Product Specifications' : 'Size Guide';
    var subtitle = t === 'drinkware'
      ? 'Dimensions and material specs for our drinkware collection.'
      : 'All measurements in inches. When in doubt, size up for a relaxed fit.';
    var tip = t === 'drinkware'
      ? '<div class="botirry-sg-tip"><strong>Care:</strong> Tumblers hand wash recommended (dishwasher OK on top rack). Ceramic mugs dishwasher + microwave safe. Avoid extreme temperature shocks.</div>'
      : '<div class="botirry-sg-tip"><strong>How to measure:</strong> Lay a similar garment flat. <strong>Chest</strong> = pit-to-pit doubled. <strong>Length</strong> = shoulder seam to hem. Between sizes, choose larger.</div>';
    modal.innerHTML = '<div class="botirry-sg-inner">' +
      '<button type="button" class="botirry-sg-close" aria-label="Close">&times;</button>' +
      '<h2 style="margin:0 0 6px;font-size:24px;color:#1a1a1a;font-weight:700">' + heading + '</h2>' +
      '<p style="margin:0 0 20px;color:#666;font-size:13px">' + subtitle + '</p>' +
      (charts[t] || charts.aop) +
      tip +
      '</div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function(e){ if (e.target === modal) modal.classList.remove('is-open'); });
    modal.querySelector('.botirry-sg-close').addEventListener('click', function(){ modal.classList.remove('is-open'); });
  }

  // Inject trigger button next to Size/Style label
  function injectBtn(){
    var t = detectType();
    var btnLabel = t === 'drinkware' ? 'Product Specs' : 'Size Guide';
    // Only target outer wrapper, avoid duplicate from nested .option-label child
    var labels = document.querySelectorAll('.m-product-option--label');
    var injected = false;
    labels.forEach(function(lbl){
      var txt = (lbl.textContent || '').toLowerCase();
      // For drinkware: match any option (no size selector). For apparel: match Size label only.
      var match = t === 'drinkware' ? true : (txt.indexOf('size') !== -1);
      if (match && !lbl.querySelector('.botirry-sg-btn')) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'botirry-sg-btn';
        btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="6" width="18" height="12" rx="2"/><line x1="7" y1="6" x2="7" y2="10"/><line x1="11" y1="6" x2="11" y2="9"/><line x1="15" y1="6" x2="15" y2="10"/><line x1="19" y1="6" x2="19" y2="9"/></svg> ' + btnLabel;
        btn.onclick = function(){
          buildModal();
          document.getElementById('botirry-sg-modal').classList.add('is-open');
        };
        lbl.appendChild(btn);
        injected = true;
      }
    });
    return injected;
  }

  function init(){
    injectBtn();
    setTimeout(injectBtn, 500);
    setTimeout(injectBtn, 1500);
    setTimeout(injectBtn, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
